const setRandomOrder = (patterns) => {
    return [
        ...patterns.filter(item => item[1] < 3).sort(() => Math.random() - 0.5),    // Randomly sorted learning patterns
        ...patterns.filter(item => item[1] == 3).sort(() => Math.random() - 0.5),   // Randomly sorted transfer patterns
    ];
};

export {
    setRandomOrder,
};